/**
 * Where is this build actually mounted?
 *
 * The same bundle is served from the apex domain (follower.psingletary.com) and
 * from a wisp subpath (sites.wisp.place/did:…/follower). The build's own script
 * tag is the only reliable anchor, so both asset URLs and the router basename
 * are derived from it instead of being hard-coded.
 */
function scriptBase() {
  const script = document.querySelector('script[src]');

  if (!script) return null;

  return new URL('../../', script.src);
}

/** URL for a file shipped in public/. */
export function assetUrl(name) {
  const base = scriptBase();

  return base ? new URL(name, base).href : `/${name}`;
}

/** Router basename: '' at the apex, '/did:…/follower' under a wisp subpath. */
export function appBasename() {
  const base = scriptBase();

  if (!base) return '';

  return base.pathname.replace(/\/$/, '');
}
